import React from "react";

import { useTranslation } from 'react-i18next';

import { shortMonthNames } from '../../../components/DateTools/MonthsNames'
import { quantityTransformer } from '../../../utils/tools'

import BayphoneCanvasChart from './BayphoneCanvasChart';


const QuantityChart = (props) => {
    const { t } = useTranslation('bayphone')
    const periodTransformer = shortMonthNames(t)
    
    const { periodStatistics } = props;

    function getChartPeriodLabel(period) {
        const dateParts = period.split("-");

        const year = dateParts[0].slice(-2);
        const month = parseInt(dateParts[1], 10);
        return `${periodTransformer[month - 1]}-${year}`;
    }

    function generateDataPoints(data, presicion = 2) {
        const dataPoints = periodStatistics.map(stat => {
            return {
                period: stat.period.date,
                plannedBudget: stat.plannedBudget,
                deviceTypeStatistics: stat.deviceTypeStatistics
            }
        });

        if (!dataPoints || dataPoints.length === 0) {
            return [];
        }

        if (!dataPoints[0].deviceTypeStatistics || dataPoints[0].deviceTypeStatistics.length === 0) {
            return [{
                type: "column",
                name: t("No Data"),
                showInLegend: true,
                dataPoints: [{ label: t("No Data"), y: 0 }]
            }];
        }

        const symbol = data?.bayphoneBudgetStatistics?.currency?.symbol? data.bayphoneBudgetStatistics.currency.symbol : ''
        const deviceTypes = new Set();

        dataPoints.forEach((p) => {
            p.deviceTypeStatistics.forEach((d) => deviceTypes.add(d.deviceType));
        });

        const deviceTypeSeries = Array.from(deviceTypes).map((deviceType) => ({
            type: "stackedColumn",
            name: deviceType,
            showInLegend: true,
            indexLabelPlacement: "inside",
            indexLabelFontColor: "black",
            click: function (e) {
                if (props.onChangePeriod) props.onChangePeriod(...e.dataPoint.period.split("-").map(arg => parseInt(arg, 10)))
            },
            dataPoints: dataPoints.map((p) => {
                const device = p.deviceTypeStatistics.find((d) => d.deviceType === deviceType);
                return {
                    label: getChartPeriodLabel(p.period),
                    period: p.period,
                    showInTooltip: true,
                    sumTotals: true,
                    y: device ? device.executedBudget : 0,
                };
            })
        }));

        const totalSeries = {
            type: "stackedColumn",
            name: t("Total"),
            showInLegend: false,
            color: "transparent",
            dataPoints: dataPoints.map((p) => {
                const total = p.deviceTypeStatistics.reduce(
                    (sum, d) => sum + d.executedBudget,
                    0
                );
                return {
                    label: p.period,
                    y: 0,
                    showInTooltip: false,
                    indexLabel: `${symbol || ''} ${quantityTransformer(total, presicion || 0)}`,
                    indexLabelFontColor: "#000",
                    indexLabelFontWeight: "bold",
                    indexLabelFontSize: 11,
                    indexLabelPlacement: "outside"
                };
            })
        };

        return [...deviceTypeSeries, totalSeries];
    }

    return (
        <BayphoneCanvasChart
            title={t("Quantities by Device Type")}
            symbol={""}
            presicion={0}
            dataPoints={generateDataPoints(periodStatistics)}
        />
    )
}

export default QuantityChart;